import { post, get } from '@/api/request'
import { PaginationResponse, PaginationParams } from '@/api/base'

// 验证请求参数
export interface VerifyParams {
  code: string
  productId?: string
}

// 产品信息
export interface ProductInfo {
  id: string
  name: string
  brand: string
  productionDate: string
  batchNumber: string
  manufacturer: string
  description?: string
  images?: string[]
}

// 验证结果
export interface VerificationResult {
  isValid: boolean
  productInfo?: ProductInfo
  verificationTime: string
  message?: string
}

// 验证历史记录
export interface VerificationHistory {
  id: number
  code: string
  isValid: boolean
  productName: string
  brand: string
  verificationTime: string
}

/**
 * 验证产品真伪
 */
// export const verifyProduct = (params: VerifyParams) => {
//   return post<VerificationResult>('/authenti-guard/v1/api/commodity-anti-counter/scan', params)
// }
export const verifyProduct = (code: string) => {
  return post<VerificationResult>(`/authenti-guard/v1/api/commodity-anti-counter/scan/${code}`)
}

/**
 * 获取验证历史
 */
export const getVerificationHistory = (params: PaginationParams = { page: 1, size: 10 }) => {
  return get<PaginationResponse<VerificationHistory>>('/verification/history', params)
}

/**
 * 获取产品详细信息
 */
export const getProductDetail = (productId: string) => {
  return get<ProductInfo>(`/verification/products/${productId}`)
}
